import React from 'react';
import {
    Box,
    Typography,
    FormControl,
    Select,
    MenuItem,
    SelectChangeEvent,
    FormHelperText,
} from '@mui/material';
import { PanIndiaDropdownProps } from '../../types/profileForm.types';

const PanIndiaDropdown: React.FC<PanIndiaDropdownProps> = ({
    label,
    value,
    error,
    onChange,
    onBlur,
}) => {
    const handleChange = (event: SelectChangeEvent<string>) => {
        const selectedValue = event.target.value === 'true';
        onChange(selectedValue);
    };

    const handleBlur = () => {
        onBlur();
    };

    return (
        <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
            <Typography
                variant="subtitle1"
                sx={{
                    minWidth: { xs: '120px', sm: '200px' },
                    flexShrink: 0,
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#212529',
                }}
            >
                {label}
            </Typography>

            <Box sx={{ flex: 1 }}>
                <FormControl fullWidth error={!!error}>
                    <Select
                        value={value.toString()}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        displayEmpty
                        sx={{
                            height: '48px',
                            borderRadius: '8px',
                            backgroundColor: '#fff',
                            fontSize: '16px',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: error ? '#dc3545' : '#dee2e6',
                                borderWidth: '1px',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: error ? '#dc3545' : '#007bff',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: error ? '#dc3545' : '#007bff',
                                borderWidth: '2px',
                            },
                            '& .MuiSelect-select': {
                                padding: '12px 16px',
                                fontSize: '16px',
                            },
                        }}
                    >
                        <MenuItem value="true">
                            <Typography sx={{ fontSize: '16px', color: '#212529' }}>
                                Yes
                            </Typography>
                        </MenuItem>
                        <MenuItem value="false">
                            <Typography sx={{ fontSize: '16px', color: '#212529' }}>
                                No
                            </Typography>
                        </MenuItem>
                    </Select>
                    {error && (
                        <FormHelperText sx={{ fontSize: '12px', color: '#dc3545', ml: 0, mt: '4px' }}>
                            {error}
                        </FormHelperText>
                    )}
                </FormControl>
            </Box>
        </Box>
    );
};

export default PanIndiaDropdown;